import styled from 'styled-components'
import RoomChargeIcon from '../../../../img/svg/roomCharge'
import { theme } from '../../../../style/theme'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const ModalHeaderWrap = styled.div`
	display: flex;
	align-items: center;
	gap: 0.62em;
	padding-right: 7.5em;

	@media screen and (max-width: ${theme.point820}) {
		margin: 0 -0.63em;
		padding: 0 0.63em 0.93em;
		border-bottom: 1px solid ${colorTheme.roomCharge.modal.stickyBorder};
		box-shadow: 0 4px 4px 0 ${colorTheme.roomCharge.modal.stickyShadow};
	}
`
ModalHeaderWrap.displayName = 'ModalHeaderWrap'

export const ModalHeaderBackButton = styled.button`
	display: grid;
	place-items: center;
	flex-shrink: 0;
	width: 3.12em;
	height: 3.12em;
	border-radius: 0.62em;
	transition: all 0.2s;
	background: ${colorTheme.roomCharge.modal.back.background};
	color: ${colorTheme.roomCharge.modal.back.icon};

	&:hover {
		filter: brightness(0.95);
	}
`
ModalHeaderBackButton.displayName = 'ModalHeaderBackButton'

export const ModalHeaderBackIcon = styled(RoomChargeIcon)`
	width: 1.31em;
	height: 1em;
`
ModalHeaderBackIcon.displayName = 'ModalHeaderBackIcon'

export const ModalHeaderContextIcon = styled.span`
	display: grid;
	place-items: center;
	flex-shrink: 0;
	width: 3.12em;
	height: 3.12em;
	border-radius: 0.62em;
	background: ${colorTheme.roomCharge.modal.context.background};
	color: ${colorTheme.roomCharge.modal.context.icon};
`
ModalHeaderContextIcon.displayName = 'ModalHeaderContextIcon'

export const ModalHeaderBedIcon = styled(RoomChargeIcon)`
	width: 1.75em;
	height: 1.43em;
`
ModalHeaderBedIcon.displayName = 'ModalHeaderBedIcon'

export const ModalHeaderTitles = styled.span`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 0.18em;
	min-width: 0;
`
ModalHeaderTitles.displayName = 'ModalHeaderTitles'

export const ModalHeaderTitle = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 1.12em;
	font-weight: 700;
	line-height: 1.25;
	color: ${colorTheme.roomCharge.modal.title};
`
ModalHeaderTitle.displayName = 'ModalHeaderTitle'

export const ModalHeaderSubtitle = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 1em;
	line-height: 1.25;
	color: ${colorTheme.roomCharge.modal.subtitle};
`
ModalHeaderSubtitle.displayName = 'ModalHeaderSubtitle'
